// import Header from "./Header";
// import Footer from "./Footer";

const Layout = ({ children }) => {
  return <div className="content">{children}</div>;
};

export default Layout;
